import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { actions } from "../../actions/actionsWrapper";
import { eFoDotDangKyPhamViActionTypeIds, IFoDotDangKyPhamViActionTypes } from "../../action-types/thuc-don/IFoDotDangKyPhamViActionTypes";
import { IBaseResponeModel } from "../../../models/response/base-response";

export function* foDotDangKyPhamViSaga(): any {
    yield takeLatest(eFoDotDangKyPhamViActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFoDotDangKyPhamViActionTypeIds.LOAD_BY_DOT_DANG_KY_START, loadByDotDangKyWorker)
    yield takeLatest(eFoDotDangKyPhamViActionTypeIds.LOAD_BY_TRUONG_START, loadByTruongWorker)
}

function* loadWorker(action: IFoDotDangKyPhamViActionTypes): any {
    try {
        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dotDangKyPhamVi.select_all);
        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_SUCCESS(res.data));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_ERROR(error.message ?? "Unexpected error occurred"));
    }
}

function* loadByDotDangKyWorker(action: IFoDotDangKyPhamViActionTypes): any {
    try {
        const payload = action.payload as number;
        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dotDangKyPhamVi.select_by_dot_dang_ky, payload);
        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_BY_DOT_DANG_KY_SUCCESS(res.data));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_BY_DOT_DANG_KY_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_BY_DOT_DANG_KY_ERROR(error.message ?? "Unexpected error occurred"));
    }
}

function* loadByTruongWorker(action: IFoDotDangKyPhamViActionTypes): any {
    try {
        const payload = action.payload as number;
        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dotDangKyPhamVi.select_by_truong, payload);
        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_BY_TRUONG_SUCCESS(res.data));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_BY_TRUONG_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyPhamVi.LOAD_BY_TRUONG_ERROR(error.message ?? "Unexpected error occurred"));
    }
}


